import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { Suspense, lazy } from 'react'
import { AuthProvider } from './contexts/AuthContext'
import { ErrorBoundary } from './components/ErrorBoundary'

import ChatWidget from '@/components/ChatWidget'

// Import Index directly for faster FCP (no lazy loading on home page)
import Index from './pages/Index'
const Dashboard = lazy(() => import('./pages/Dashboard'))
const JobDetails = lazy(() => import('./pages/JobDetails'))
const ApplyJob = lazy(() => import('./pages/ApplyJob'))
const SubmitJob = lazy(() => import('./pages/SubmitJob'))
const EditJob = lazy(() => import('./pages/EditJob'))
const Auth = lazy(() => import('./pages/Auth'))
const Profile = lazy(() => import('./pages/Profile'))
const Announcements = lazy(() => import('./pages/Announcements'))
const Contact = lazy(() => import('./pages/Contact'))
const Help = lazy(() => import('./pages/Help'))
const Privacy = lazy(() => import('./pages/Privacy'))
const Terms = lazy(() => import('./pages/Terms'))
const Sitemap = lazy(() => import('./pages/Sitemap'))
const NotFound = lazy(() => import('./pages/NotFound'))
const AdminUserProfile = lazy(() => import('@/components/AdminUserProfile').then(module => ({ default: module.AdminUserProfile })))

const queryClient = new QueryClient()

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Toaster />
        <Router>
          <ErrorBoundary>
            <Suspense fallback={<div className="loading-spinner" />}>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/job/:id" element={<JobDetails />} />
                <Route path="/apply/:id" element={<ApplyJob />} />
                <Route path="/submit-job" element={<SubmitJob />} />
                <Route path="/edit-job/:id" element={<EditJob />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/announcements" element={<Announcements />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/help" element={<Help />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/sitemap" element={<Sitemap />} />
                
                {/* Admin routes */}
                <Route path="/admin/users/:userId" element={<AdminUserProfile />} />
                
                {/* Catch-all route for 404s */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </ErrorBoundary>
          <ChatWidget />
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  )
}

export default App
